import { AutogenLayoutOfficeLeaveStatementsReport } from "./autogen/AutogenLayoutOfficeLeaveStatementsReport";

/**
 * Office Leave Statements Report - Extension class with custom business logic
 */
export class OfficeLeaveStatementsReport extends AutogenLayoutOfficeLeaveStatementsReport {

    override onLoad(): void {
        super.onLoad();
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
    }
}
